import { PermitMeasurementContext } from '@src/common/measurements/PermitMeasurementContext';
import { useContext } from 'react';

export const usePermitMeasurement = () => {
  return useContext(PermitMeasurementContext);
};
